function checkNetworkError(error: any, defaultErrorCallback: () => void, networkErrorCallback: () => void) {
	if (error.status <= 0) {
		networkErrorCallback();
	}
	else {
		defaultErrorCallback();
	}
}
